import React, { memo } from 'react';
export function ProblemSection() {
  return <section className="bg-amber-50 py-16 md:py-24 px-4" data-id="element-151">
      <div className="max-w-3xl mx-auto" data-id="element-152">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-stone-900 mb-8 text-center" data-id="element-153">
          El problema que nadie le cuenta
        </h2>
        <div className="space-y-6 text-lg md:text-xl text-stone-700 leading-relaxed" data-id="element-154">
          <p data-id="element-155">
            El mundo moderno va muy rápido. Las aplicaciones de memoria están en
            inglés, son complicadas y parecen juguetes para niños. Mientras
            tanto, el miedo a depender de otros o a perder el hilo de una
            conversación se vuelve una sombra constante.
          </p>
          <p data-id="element-156">
            Ese estrés genera cortisol, una toxina que bloquea sus recuerdos.
            Cuanto más se esfuerza por recordar "a la fuerza", más se esconde la
            información. No es falta de inteligencia; es una saturación del
            sistema que necesita un método humano y cercano.
          </p>
        </div>
      </div>
    </section>;
}